/**
 * Aligns product card images in featured collection rows by equalizing
 * the height of each card's info block (title, subtitle, price).
 */
class FeaturedCollectionCardAlign {
  constructor(container) {
    this.container = container;
    this.grid = container.querySelector('.product-grid');
    if (!this.grid) return;

    this.align = this.align.bind(this);
    this.scheduleAlign = this.scheduleAlign.bind(this);

    this.resizeObserver = new ResizeObserver(this.scheduleAlign);
    this.resizeObserver.observe(this.grid);

    if (document.fonts?.ready) {
      document.fonts.ready.then(this.scheduleAlign);
    }

    this.scheduleAlign();
  }

  scheduleAlign() {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => this.align());
  }

  align() {
    const items = [...this.grid.querySelectorAll(':scope > .grid__item')];
    const infoBlocks = items
      .map((item) => item.querySelector('.card__information'))
      .filter(Boolean);

    infoBlocks.forEach((block) => {
      block.style.minHeight = '';
    });

    if (!items.length) return;

    const rows = new Map();

    items.forEach((item) => {
      const top = item.offsetTop;
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(item);
    });

    rows.forEach((rowItems) => {
      const blocks = rowItems
        .map((item) => item.querySelector('.card__information'))
        .filter(Boolean);

      const maxHeight = Math.max(0, ...blocks.map((block) => block.offsetHeight));

      blocks.forEach((block) => {
        block.style.minHeight = `${maxHeight}px`;
      });
    });
  }

  disconnect() {
    this.resizeObserver?.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
  }
}

function initFeaturedCollectionCardAlign(root = document) {
  root.querySelectorAll('.featured-collection').forEach((container) => {
    if (container._featuredCollectionCardAlign) {
      container._featuredCollectionCardAlign.scheduleAlign();
      return;
    }

    container._featuredCollectionCardAlign = new FeaturedCollectionCardAlign(container);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFeaturedCollectionCardAlign());
} else {
  initFeaturedCollectionCardAlign();
}

document.addEventListener('shopify:section:load', (event) => {
  initFeaturedCollectionCardAlign(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('.featured-collection').forEach((container) => {
    container._featuredCollectionCardAlign?.disconnect();
    delete container._featuredCollectionCardAlign;
  });
});
